import { render, staticRenderFns } from "./carousel-product-component.vue?vue&type=template&id=8b678f20&scoped=true"
import script from "./carousel-product-component.vue?vue&type=script&lang=js"
export * from "./carousel-product-component.vue?vue&type=script&lang=js"
import style0 from "./carousel-product-component.vue?vue&type=style&index=0&id=8b678f20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b678f20",
  null
  
)

export default component.exports